import * as React from 'react';
import Bunny from './Seasons/Bunny';
import Ghost from './Seasons/Ghost';
import Snow from './Seasons/Snow';

const Seasonal = () => {
  React.useEffect(() => {
    const d = new Date();
    const n = d.getMonth();

    const init = (parentElement: HTMLElement) => {
      return new Promise(
        (
          resolve: ({
            canvas,
            ctx,
            parentElement,
            onResize
          }: {
            canvas: HTMLCanvasElement;
            ctx: CanvasRenderingContext2D;
            parentElement: HTMLElement;
            onResize: () => void;
          }) => void,
          reject
        ) => {
          if (!parentElement) reject('No parent element selected!');
          const canvas = document.createElement('canvas');

          const onResize = () => {
            canvas.width = parentElement.offsetWidth;
            canvas.height = parentElement.offsetHeight;
          };

          canvas.id = 'sfxCanvas';
          console.log(parentElement.tagName);
          canvas.style.position = parentElement.tagName === 'BODY' ? 'fixed' : 'absolute';
          canvas.style.bottom = '0';
          canvas.style.left = '0';
          canvas.style.pointerEvents = 'none';
          canvas.width = parentElement.offsetWidth;
          canvas.height = parentElement.offsetHeight;
          parentElement.appendChild(canvas);
          const ctx = canvas.getContext('2d');

          if (ctx === null) reject('Unable to get Canvas Context!');
          else resolve({ canvas, ctx, parentElement, onResize });
        }
      );
    };

    if (n === 10 || n === 11 || n === 0) {
      console.log('starting snow...');
      init(document.getElementById('sfxContainer') ?? document.body).then(
        ({ canvas, ctx, parentElement, onResize }) => {
          Snow({ canvas, ctx, parentElement, onResize });
        }
      );
    }

    if (n === 1 || n === 2 || n === 3) {
      console.log('starting bunny...');
      init(document.getElementById('sfxContainer') ?? document.body).then(
        ({ canvas, ctx, parentElement, onResize }) => {
          Bunny({ canvas, ctx, parentElement, onResize });
        }
      );
    }

    if (n === 4 || n === 5 || n === 6 || n === 7) {
      console.log('starting floatie...');
      const frame = document.createElement('iframe');
      frame.style.width = '100%';
      frame.style.height = '100%';
      frame.src = '/seasons/summer/index.html';

      const span = document.createElement('span');
      span.innerHTML =
        'Model by <a style="color:black" target="_blank" href="https://sketchfab.com/braulio.dominguez">Braulio Domiguez</a> - (<a style="color:black" target="_blank" href="https://creativecommons.org/licenses/by/4.0/">CC BY 4.0</a>)';
      span.style.position = 'absolute';
      span.style.bottom = '0';
      span.style.right = '0';
      span.style.color = 'black';
      span.style.fontSize = '0.5em';
      span.style.backgroundColor = 'white';
      span.style.opacity = '0.7';
      document.getElementById('sfxContainer')?.append(frame);
      document.getElementById('sfxContainer')?.append(span);
    }

    if (n === 9) {
      const sfxContainer = document.getElementById('sfxContainer');
      if (sfxContainer) {
        sfxContainer.style.height = window.innerHeight + 'px';
        sfxContainer.style.width = window.innerWidth + 'px';
        sfxContainer.style.position = 'fixed';
        sfxContainer.style.top = '0';
        sfxContainer.style.left = '0';
        sfxContainer.style.zIndex = '999';
        sfxContainer.style.pointerEvents = 'none';
      }
      init(document.getElementById('sfxContainer') ?? document.body).then(
        ({ canvas, ctx, parentElement, onResize }) => {
          Ghost(canvas, ctx, parentElement, onResize);
        }
      );
    }

    return () => {
      if (n === 9 || n === 11 || n < 3) document.getElementById('sfxCanvas')?.remove();
    };
  }, []);

  return null;
};

export default Seasonal;
